<template>
	<div id="alumni">
		<lead />
		<main class="main">
			<keep-alive include="news">
				<router-view :key="this.$route.query.id" />
			</keep-alive>
		</main>
		<foote />
	</div>
</template>

<script>
	import lead from './head';
	import foote from './footer';
	export default{
		components: {
			lead,foote,
		}
	}
</script>
<style lang="scss">
	.main{
		min-height: calc(100vh - 164px);
		padding: 25px 0 0;
		font-family: MicrosoftYaHei;
		.pointer:hover{
			cursor:pointer;
		}
	}
</style>